import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

// Enable credentials for all axios requests
//axios.defaults.withCredentials = true;

const syncKey =
  'wsvnitrugwocxdedjutfkntvdnuqtvlubjrdmhcvbsqpftzkmrcmbtzgkkusnmpheummzssesvtahhuorvgstflpbxqgbzpo';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    balances: [],
    categories: [],
    transactions: [],
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setBalances(state, balances) {
      state.balances = balances;
    },
    setBalanceTriangon(state, balance) {
      state.balanceTriangon = balance;
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
    setTransactions(state, transactions) {
      state.transactions = transactions;
    },
  },
  actions: {
    async getUser({ commit }) {
      return axios
        .get(`${process.env.VUE_APP_BASE_URL_API}/api/user`, {
          headers: {
            Authorization:
              'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            commit('setUser', res.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getBalances({ commit }) {
      return axios
        .get(`${process.env.VUE_APP_BASE_URL_API}/api/balance`, {
          headers: {
            Authorization:
              'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            commit('setBalances', res.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getCsrfToken({ _ }, payload) {
      return axios
        .get(`${process.env.VUE_APP_BASE_URL_API}/sanctum/csrf-cookie`)
        .then((res) => {
          console.log(res);
          if (res.status == 200 || res.status == 204) {
            return axios
              .post(`${process.env.VUE_APP_BASE_URL_API}/api/login`, {
                email: payload.email,
                password: payload.password,
              })
              .then((res) => {
                console.log(_);
                localStorage.setItem(
                  'triangon_budgeting_token',
                  res.data.token
                );
                return res;
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getCategories({ commit }) {
      return axios
        .get(`${process.env.VUE_APP_BASE_URL_API}/api/categories`, {
          headers: {
            Authorization:
              'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            commit('setCategories', res.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getTransactions({ commit }) {
      return axios
        .get(
          `${process.env.VUE_APP_BASE_URL_API}/api/transactions?processed=0`,
          {
            headers: {
              Authorization:
                'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            commit('setTransactions', res.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getTransactionsByDateRange(
      { commit },
      { dateFrom, dateTo, category_id }
    ) {
      const params = {
        date_from: dateFrom,
        date_to: dateTo,
      };

      // Add category_id if provided
      if (category_id) {
        params.category_id = category_id;
      }

      console.log('API call with params:', params);

      return axios
        .get(
          `${process.env.VUE_APP_BASE_URL_API}/api/transactions/date-range`,
          {
            params,
            headers: {
              Authorization:
                'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            console.log(
              'Received transactions:',
              res.data.length,
              'transactions'
            );
            console.log(
              'Date range of received transactions:',
              res.data.length > 0
                ? {
                    first: res.data[0]?.created_at,
                    last: res.data[res.data.length - 1]?.created_at,
                  }
                : 'No transactions'
            );
            commit('setTransactions', res.data);
            return res.data;
          }
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },
    async saveNewBudget({ _ }, payload) {
      console.log(payload);
      return axios
        .put(
          `${process.env.VUE_APP_BASE_URL_API}/api/categories/${payload.id}`,
          payload.data,
          {
            headers: {
              Authorization:
                'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            console.log(_);
            return res.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async processTransaction({ _ }, payload) {
      return axios
        .put(
          `${process.env.VUE_APP_BASE_URL_API}/api/transactions/${payload.id}`,
          payload.data,
          {
            headers: {
              Authorization:
                'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            console.log(_);
            return res.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async createTransaction({ _ }, transactionData) {
      console.log('Creating new transaction:', transactionData, _);
      return axios
        .post(
          `${process.env.VUE_APP_BASE_URL_API}/api/transactions`,
          transactionData,
          {
            headers: {
              Authorization:
                'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
            },
          }
        )
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            console.log('Transaction created successfully:', res.data);
            return res.data;
          }
        })
        .catch((error) => {
          console.log('Error creating transaction:', error);
          throw error;
        });
    },
    async splitTransaction({ _ }, payload) {
      console.log('Splitting transaction with payload:', payload);
      console.log(_);
      try {
        const [firstSplit, ...additionalSplits] = payload.splits;

        // Update the original transaction with the first split data (using processTransaction)
        console.log(
          'Updating original transaction with first split:',
          firstSplit
        );
        await axios.put(
          `${process.env.VUE_APP_BASE_URL_API}/api/transactions/${payload.originalTransactionId}`,
          {
            amount: firstSplit.amount,
            category_id: firstSplit.category_id,
            description: firstSplit.description,
            processed: firstSplit.processed,
          },
          {
            headers: {
              Authorization:
                'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
            },
          }
        );
        console.log('Original transaction updated successfully');

        // Create new transactions for the additional splits
        if (additionalSplits.length > 0) {
          const createPromises = additionalSplits.map((split) => {
            return axios.post(
              `${process.env.VUE_APP_BASE_URL_API}/api/transactions`,
              split,
              {
                headers: {
                  Authorization:
                    'Bearer ' +
                    localStorage.getItem('triangon_budgeting_token'),
                },
              }
            );
          });

          const createResults = await Promise.all(createPromises);
          console.log(
            'Additional split transactions created successfully:',
            createResults.length
          );

          return {
            updated: 1,
            created: createResults.map((res) => res.data),
          };
        }

        return {
          updated: 1,
          created: [],
        };
      } catch (error) {
        console.log('Error splitting transaction:', error);
        throw error;
      }
    },
    async logout() {
      localStorage.removeItem('triangon_budgeting_token');
      return axios
        .post(`${process.env.VUE_APP_BASE_URL_API}/api/logout`, null, {
          headers: {
            Authorization:
              'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
          },
        })
        .then(() => {
          location.reload();
        })
        .catch(() => {
          location.reload();
        });
    },
    async sync() {
      return axios
        .get(
          `https://script.google.com/macros/s/AKfycbwuTx_hvrliDStI2OT5hTX9r5L0itJaX8qzNDIlTsZd5JtYzgbj3QI8EA8imf7Wi3D7Bg/exec?syncKey=${syncKey}`,
          null,
          {
            headers: {
              Authorization:
                'Bearer ' + localStorage.getItem('triangon_budgeting_token'),
            },
          }
        )
        .catch(() => {
          throw new Error('Error while syncing');
        });
    },
  },
  modules: {},
});
